<template>
  <div ref="outer" class="overflow-hidden d-flex flex-row flex-fill flex-grow-1" >
    <v-fade-transition group
                       class="text-no-wrap d-flex flex-row transition-ease-in-out"
                       :style="styles"
                       mode="out-in"
    >
      <div v-for="(item, index) in items" :key="index" ref="inner">
        <Anchor :to="to(item)" class="text-caption" :dark="dark" v-text="item.text" />
        <v-fade-transition>
          <v-icon v-if="index < items.length - 1" x-small class="mx-1">
            mdi-chevron-right
          </v-icon>
        </v-fade-transition>
      </div>
    </v-fade-transition>
  </div>
</template>

<script>
import Anchor from '@/components/Anchor';

export default {
  name: 'Breadcrumbs',
  components: { Anchor },
  props: {
    items: { type: Array, default: () => [] }
  },
  data: () => ({
    delta: 0,
  }),
  computed: {
    dark() { return this.$store.state.theme.stickyHeaderDark; },
    styles() {
      return {
        marginLeft: `${this.delta}px`
      };
    },
  },
  watch: {
    items() {
      this.$nextTick(() => this.update());
    }
  },
  mounted() {
    this.update();
  },
  methods: {
    update() {
      const { outer, inner } = this.$refs;
      if (outer && inner) {
        const widthOuter = outer.offsetWidth;
        let widthInner = 0;
        let delta = 0;
        for (let i = inner.length - 1; i >= 0; i--) {
          const w = inner[i].offsetWidth;
          widthInner += w;
          if (widthInner > widthOuter) {
            delta -= w;
          }
        }
        this.delta = delta;
      }
    },
    to: ({ id }) => ({ name: 'showcase', params: { section: id } }),
  }
};
</script>
